import * as Types from '/ui/components/table/types';

/**
 * @typedef {{
 *   columns: !Array<!Types.Column>,
 * }}
 */
let TableColgroupProps;

/**
 * @param {!TableColgroupProps} props
 * @return {React.ReactElement}
 */
export function TableColgroup({columns}) {
  return (
    <colgroup>
      {columns.map(renderCol)}
    </colgroup>
  );
}

/**
 * @param {!Types.Column} column
 * @return {React.ReactElement}
 */
function renderCol({id, className, width}) {
  return (
    <col
      key={id}
      className={className}
      style={{'width': width}}
    />
  );
}
